import { IconSearch } from "@tabler/icons-react";
import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { css } from "styled-system/css";
import { Box, Center, Container, Flex, Grid, GridItem, HStack } from "styled-system/jsx";
import { useDebouncedCallback } from "use-debounce";
import { Badge, EmptyState, Icon, Input, Pagination } from "~/components";

const getRoute = getRouteApi("/_layout/cooperation/");

export const List = () => {
  const result = getRoute.useLoaderData();
  const params = getRoute.useSearch();
  const navigate = useNavigate({ from: "/cooperation" });

  const debouncedSearch = useDebouncedCallback((value: string) => {
    navigate({
      search: (prev) => ({ ...prev, page: 1, keyword: value }),
      replace: true,
    });
  }, 500);

  return (
    <Container maxW="7xl" mt={10} mb={20}>
      <Flex flexDir="column" gap="10">
        <h1
          className={css({
            textStyle: "h6",
            color: "disabled",
            fontWeight: "bold",
          })}
        >
          Data Koperasi
        </h1>
        <Box position="relative" role="group" tabIndex={1}>
          <Icon
            pos="absolute"
            height="54px"
            display="flex"
            flexDir="column"
            alignItems="center"
            left={4}
            className={css({ color: "primary" })}
          >
            <IconSearch />
          </Icon>
          <Input
            borderRadius="12"
            size="md"
            pl="40px"
            minW={{ base: "0", md: "412px" }}
            width="full!"
            placeholder="Cari koperasi"
            defaultValue={params.keyword}
            onChange={(e) => debouncedSearch(e.target.value)}
          />
        </Box>
        {result.data.list.length === 0 ? (
          <Center>
            <EmptyState
              title="Belum ada data koperasi"
              description="Data koperasi yang tersedia akan muncul di halaman ini."
            />
          </Center>
        ) : (
          <Flex gap="40px" flexDir="column">
            <Grid gridTemplateColumns={{ base: "1", sm: "2", lg: "3" }} gap="24px">
              {result.data.list.map((v) => {
                const place = [v.district, v.city].filter(Boolean).join(", ");
                return (
                  <GridItem key={v.id}>
                    <Flex
                      flexDir="column"
                      gap="2"
                      h="full"
                      border="1px solid #E4E7EC"
                      borderRadius="16px"
                      p="20px"
                    >
                      <p className={css({ textStyle: "lg", fontWeight: "bold", color: "secondary.darken8" })}>
                        {v.name}
                      </p>
                      {v.legalEntityNo && (
                        <p className={css({ textStyle: "sm", color: "disabled.text" })}>
                          No. Badan Hukum: {v.legalEntityNo}
                        </p>
                      )}
                      {place && (
                        <p className={css({ textStyle: "sm", color: "secondary.darken6" })}>{place}</p>
                      )}
                      {v.address && (
                        <p className={css({ textStyle: "sm", color: "secondary.darken6" })}>{v.address}</p>
                      )}
                      <HStack gap="2" mt="1" flexWrap="wrap">
                        {v.isActive ? (
                          <Badge colorPalette="primary" bgColor="green.lighten1" borderRadius="8px">
                            Aktif
                          </Badge>
                        ) : null}
                        {v.hasCertificate ? (
                          <Badge colorPalette="secondary" borderRadius="8px">
                            Bersertifikat
                          </Badge>
                        ) : null}
                      </HStack>
                    </Flex>
                  </GridItem>
                );
              })}
            </Grid>
            <Center>
              <Pagination
                count={result.data.paging.count}
                pageSize={result.data.paging.limit}
                siblingCount={0}
                page={result.data.paging.page}
                onPageChange={(v) => {
                  navigate({ search: (prev) => ({ ...prev, page: v.page }) });
                }}
              />
            </Center>
          </Flex>
        )}
      </Flex>
    </Container>
  );
};
